import { SvgIcon } from '@mui/material';
import React from 'react';

export default function AddIcon({ ...props }) {
  return (
    <SvgIcon
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M18.7901 9.23641H10.6321V1.07847C10.6321 0.627927 10.2669 0.262695 9.81636 0.262695C9.36582 0.262695 9.00058 0.627927 9.00058 1.07847V9.23637H0.842635C0.392088 9.23641 0.0268555 9.60164 0.0268555 10.0522C0.0268555 10.5027 0.392088 10.868 0.842635 10.868H9.00055V19.0259C9.00055 19.4764 9.36578 19.8416 9.81633 19.8416C10.2669 19.8416 10.6321 19.4764 10.6321 19.0259V10.868H18.79C19.2406 10.868 19.6058 10.5027 19.6058 10.0522C19.6059 9.60164 19.2406 9.23641 18.7901 9.23641Z" />
    </SvgIcon>
  );
}
